import { motion, AnimatePresence } from 'framer-motion';
import { sections } from '../data/portfolioData';

interface NavigationArrowsProps {
  selectedIndex: number | null;
  onSelect: (index: number) => void;
}

export default function NavigationArrows({ selectedIndex, onSelect }: NavigationArrowsProps) {
  return (
    <AnimatePresence>
      {selectedIndex === null && (
        <div className="fixed bottom-6 inset-x-0 z-50 flex justify-center pointer-events-none px-3">
          <motion.nav
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            className="pointer-events-auto flex items-center gap-1.5 px-3 py-2.5 rounded-2xl
                       border border-white/10 backdrop-blur-xl
                       max-w-full overflow-x-auto"
            style={{
              background: 'linear-gradient(135deg, rgba(10,10,32,0.85), rgba(5,5,16,0.9))',
              scrollbarWidth: 'none',
            }}
            aria-label="Portfolio sections"
          >
            <span className="text-[11px] text-gray-500 font-mono uppercase tracking-wider mx-2 hidden lg:inline">
              Explore
            </span>
            {sections.map((section, i) => (
              <button
                key={section.id}
                onClick={() => onSelect(i)}
                aria-label={section.title}
                className="group relative flex-shrink-0 h-9 px-2.5 rounded-xl
                           flex flex-col items-center justify-center leading-none
                           transition-all duration-300 hover:scale-105"
                style={{
                  background: `${section.color}0d`,
                  border: `1px solid ${section.color}22`,
                }}
                onMouseEnter={(e) => {
                  (e.currentTarget as HTMLElement).style.background = `${section.color}22`;
                  (e.currentTarget as HTMLElement).style.borderColor = `${section.color}55`;
                  (e.currentTarget as HTMLElement).style.boxShadow = `0 0 15px ${section.color}25`;
                }}
                onMouseLeave={(e) => {
                  (e.currentTarget as HTMLElement).style.background = `${section.color}0d`;
                  (e.currentTarget as HTMLElement).style.borderColor = `${section.color}22`;
                  (e.currentTarget as HTMLElement).style.boxShadow = 'none';
                }}
              >
                <span
                  className="font-mono text-[11px] font-medium tracking-wider"
                  style={{ color: section.color }}
                >
                  {section.code}
                </span>
                <span className="font-mono text-[7px] text-gray-600 mt-0.5">
                  {String(i + 1).padStart(2, '0')}
                </span>

                <span
                  className="absolute -top-9 left-1/2 -translate-x-1/2
                             px-2.5 py-1 rounded-md text-[10px] whitespace-nowrap
                             opacity-0 group-hover:opacity-100 transition-opacity
                             pointer-events-none font-mono"
                  style={{
                    background: 'rgba(5,5,16,0.95)',
                    border: `1px solid ${section.color}30`,
                    color: section.color,
                  }}
                >
                  {section.title}
                </span>
              </button>
            ))}
          </motion.nav>
        </div>
      )}
    </AnimatePresence>
  );
}
